import base from './base';

export default {
  mixins: [base],
  props: {
    model: { type: Object, required: true },
  },
};
